let baseURL = process.env.REACT_APP_BASE_API;; // 接口地址获取
// 区分生产环境和开发环境时的接口地址
// TODO: 配置ENV以及ENV.local来使不同开发者使用不同的开发url

let casURL = process.env.REACT_APP_CAS_API;
let adminPannelURL = process.env.REACT_APP_PANNEL_API;
export default{
    baseURL,
    casURL,
    adminPannelURL
}